import Cookies from "universal-cookie";
import { getIds } from "../../../../../../../../../controllers/adicionarFichaTecnica";
import config from "../../../../../../../../../controllers/config";

export async function loadIds(alfa) {
    const cookies = new Cookies();
    const token = cookies.get("User-Token");
    const filters = { alfa };

    const ids = await getIds(token, filters)
        .then((response) => {
            const { statusCode } = response.res;

            if (statusCode !== 200) {
                if (statusCode === false && message && message.includes("Token inválido!")) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários não foram retornados pelo servidor!");
                }
            }

            let body = JSON.parse(response.body);

            const r_ids = body.ids.map((id) => {
                return {
                    id: id[0],
                    nome: id[1],
                    idDescr: id[2],
                };
            });

            return r_ids;
        })
        .catch((error) => {
            let errorString = "Erro ao carregar dados!";
            if (config.DEBUG === "TRUE") {
                errorString = error.message;
            }
        });

    return ids;
}
